import React from 'react';
import { useTranslation } from 'react-i18next';
import FeaturedSectionStats from '../../ui/FeaturedSectionStats';
import './IntroSectionPrivateCloud.css';

const IntroSectionPrivateCloud3: React.FC = () => {
  const { t } = useTranslation();

  // Data for FeaturedSectionStats specific to Private Cloud
  const privateCloudStats = [
    {
      value: '100%',
      label: 'Contrôle des données',
      translationKey: 'privateCloud.stats.control',
      labelTranslationKey: 'privateCloud.stats.controlLabel'
    },
    {
      value: '24/7',
      label: 'Surveillance continue',
      translationKey: 'privateCloud.stats.monitoring',
      labelTranslationKey: 'privateCloud.stats.monitoringLabel'
    },
    {
      value: '99.9%',
      label: 'Disponibilité garantie',
      translationKey: 'privateCloud.stats.uptime',
      labelTranslationKey: 'privateCloud.stats.uptimeLabel'
    },
    {
      value: '∞',
      label: 'Évolutivité sur mesure',
      translationKey: 'privateCloud.stats.scalability',
      labelTranslationKey: 'privateCloud.stats.scalabilityLabel'
    }
  ];

  return (
    <div className="intro-section-home intro-section-private-cloud">
      <div className="intro-row-1 tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-8 tw-items-center tw-pt-[4em] max-[734px]:tw-pt-0">
        <div className="intro-text-1">
          <h2 style={{ fontSize: '62px', paddingBottom: '12px' }}>{t('privateCloud.introSection.commitment', 'Notre engagement')}</h2>
        </div>
      </div>

      <FeaturedSectionStats
        title="Un cloud privé sur mesure qui grandit avec votre entreprise."
        subtitle="Nous concevons et gérons votre infrastructure cloud privée pour vous offrir contrôle, performance et sécurité maximale de vos données."
        titleTranslationKey="privateCloud.stats.title"
        subtitleTranslationKey="privateCloud.stats.subtitle"
        stats={privateCloudStats}
        showChart={false}
      />
    </div>
  );
};

export default IntroSectionPrivateCloud3;
